import React from 'react';

export default function LoadingSpinner({ size = 'medium', color = '#8B4513' }) {
  const sizes = {
    small: 20,
    medium: 40,
    large: 60
  };

  const dimension = sizes[size] || sizes.medium;

  return (
    <div style={{
      width: dimension,
      height: dimension,
      border: `3px solid rgba(139, 69, 19, 0.1)`,
      borderTop: `3px solid ${color}`,
      borderRadius: '50%',
      animation: 'spin 0.8s linear infinite'
    }}>
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}